<template>
  <div class="box">
    <cube-input
      :value="value"
      @input="$emit('input', $event)"
      placeholder="请输入验证码"
    ></cube-input>
    <cube-button class="button" inline :disabled="time > 0" @click="getSMS">{{
      time > 0 ? `${time}s后重新获取` : "获取验证码"
    }}</cube-button>
  </div>
</template>

<script>
import { sendValidationSms } from '@/api/user';

export default {
  name: 'SMSInput',
  props: {
    value: String,
    mobile: String,
  },
  data() {
    return {
      time: 0,
    };
  },
  methods: {
    getSMS() {
      sendValidationSms({ userMobile: this.mobile })
        .then((res) => {
          if (res.code === 0) {
            this.time = 5;
            const timer = setInterval(() => {
              if (this.time <= 0) {
                clearInterval(timer);
              } else {
                this.time -= 1;
              }
            }, 1000);
            return res.data;
          }
          return Promise.reject(Error(res.msg));
        })
        .catch((err) => {
          this.$createToast({
            type: 'txt',
            txt: err.message || '服务器繁忙, 请稍后再试',
            mask: true,
            time: 2000,
          }).show();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
}
.button {
  color: #2967ea;
  background: white;
}
</style>
